import { memo } from 'react'
import { useIntl } from 'react-intl'
import OfferCardCarouselSection, { MIN_OFFER_CAROUSEL_OFFERS_COUNT } from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from 'constants/search'

const FILTERS: App.OfferListFilters = {
  destinations: [ANYWHERE_PLACE_ID],
  destinationNames: [ANYWHERE_NAME],
  loyalty: ['Free Room Upgrade'],
  offerTypes: ['hotel'],
}

const VIEW_ALL_LINK = `/search?${getSearchQueryFromFilter(FILTERS)}`

function SocieteStayUpgradeCarousel() {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'IKewHt4dCJYn3FiuKU1W',
    defaultMessage: 'Upgrade your stay for free with Société',
    description: 'Heading title for Société stay upgrade carousel on the homepage',
  })

  return (
    <OfferCardCarouselSection
      filters={FILTERS}
      title={title}
      allLink={VIEW_ALL_LINK}
      tileStyle="card-default"
      tileSize="medium"
      minimumOffersCount={MIN_OFFER_CAROUSEL_OFFERS_COUNT}
      id="societe-stay-upgrade-carousel"
      data-testid="societe-stay-upgrade-carousel"
    />
  )
}

export default memo(SocieteStayUpgradeCarousel)
